/* eslint-disable jsx-a11y/img-redundant-alt */
import { Box } from '@material-ui/core';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'reactstrap';

const texts = {
  success: {
    image: '/clients/motorplay/assets/images/ic_clock.svg',
    altImage: 'approved payment image',
    title: 'PaymentStatus.subscription.messages.default.title',
    text: 'PaymentStatus.ppv.messages.header',
    buttonText: 'PaymentStatus.subscription.buttons.SUCCESSFUL.submit'
  },
  successCanceledSubscription: {
    image: '/clients/motorplay/assets/images/ic_approved.svg',
    altImage: 'approved payment image',
    title: 'CancelStatus.subscription.messages.default.title',
    text: 'CancelStatus.subscription.messages.body',
    buttonText: 'PaymentStatus.subscription.buttons.SUCCESSFUL.submit'
  },
  failedCanceledSubscription: {
    image: '/clients/motorplay/assets/images/ic_rejected.svg',
    altImage: 'rejected payment image',
    title: 'CancelStatus.subscription.messages.failed.title',
    text: 'CancelStatus.subscription.messages.failed.body',
    buttonText: 'PaymentStatus.subscription.buttons.SUCCESSFUL.submit'
  },
  successCoupon: {
    image: '/clients/motorplay/assets/images/ic_approved.svg',
    altImage: 'approved payment image',
    title: 'payment.by.freepass.coupon.success.title',
    text: 'PaymentStatus.ppv.messages.body',
    buttonText: 'PaymentStatus.subscription.buttons.SUCCESSFUL.submit'
  },
  failed: {
    image: '/clients/motorplay/assets/images/ic_rejected.svg',
    altImage: 'rejected payment image',
    title: 'PaymentStatus.subscription.messages.rejected.title',
    text: 'PaymentStatus.subscription.messages.error.body',
    buttonText: 'PaymentStatus.subscription.buttons.500.submit'
  }
}


export const Modal = ({type = 'success', closeModal, message }) => {
  const text = texts[type]
  return (
    <Box
      className='modal-container'
    >
      <Box className='modal-content'>
        <img src={text.image} alt={text.altImage}/>
        <h3><FormattedMessage id={text.title} /></h3>
        <p><FormattedMessage id={text.text} /></p>
        <span>{message}</span>
        <Button
            onClick={closeModal}
          >
            <FormattedMessage id={text.buttonText} />
          </Button>
      </Box>
    </Box>
  );
};
